/**
 * GlobalNav
 * タブレット以下でアコーディオンが必要なため作成
 */

import { functions } from "../../modules/functions";

export module GlobalNavModule {
  export class Service {
    constructor(language?: string) {
      document.addEventListener('readCompleteAction', () => {
        Service.globalNavAction();
      });
    }

    /**
     * アコーディオン処理
     */
    public static globalNavAction() {
      let $elements = document.getElementsByClassName('js__accordion--gnav');
      if ($elements && $elements.length) {
        for (let $i = 0; $i < $elements.length; $i++) {
          let $element = $elements[$i];

          // 要素の追加.
          let $createElement = document.createElement('i');
          $createElement.classList.add('icon', 'icon--globalNav');
          $element.insertBefore($createElement, $element.firstChild);

          // イベントの追加.
          $createElement.addEventListener('click', () => {
            const $self = $createElement;
            const $parent = $createElement.closest('li');
            if ($parent) {
              const $accordionElements = $parent.children;
              let $accordionElement;
              for (let $j = 0; $j < $accordionElements.length; $j++) {
                if ($accordionElements[$j].classList.contains('sub-menu-wrap')) {
                  $accordionElement = $accordionElements[$j];
                }
              }

              $parent.classList.toggle('js__active');
              if ($accordionElement) {
                if ($parent.classList.contains('js__active')) {
                  functions.slideDown(($accordionElement as HTMLElement));
                } else {
                  functions.slideUp(($accordionElement as HTMLElement));
                }
              }
            }
          });
        }
      }
    }
  }
}